module.exports = __webpack_public_path__ + "static/media/photo2.fb869ff7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo2.png
// module id = 508
// module chunks = 0